﻿import {NamedValue, translation} from "@2d-front-monorepo/core";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import IEntityResult from "../interfaces/IEntityResult";
import {DriverId} from "../nominalTypes/DriverId";
import {ResidencyId} from "../nominalTypes/ResidencyId";
import {VehicleId} from "../nominalTypes/VehicleId";
import {useMemo} from "react";

type AllowedId = DriverId | ResidencyId | VehicleId;
type ExtractId<T> = T extends IEntityResult<infer TId> ? TId : never;

export default function useCreateSelectItems<T extends IEntityResult<AllowedId>>(items: T[] | undefined, createEnabled: boolean | undefined, label: (item: T) => string): NamedValue<ExtractId<T>>[] {
	return useMemo(() => {
		const result: NamedValue<ExtractId<T>>[] = [];

		// result.push({
		// 	label: translation(PermitTranslations.select_an_option),
		// 	value: "" as ExtractId<T>
		// })

		if (createEnabled) {
			result.push({
				label: translation(PermitTranslations.add_new),
				value: "create" as ExtractId<T>
			});
		}

		if (items) {
			result.push(
				...items.map(r => {
					return {value: r.id as ExtractId<T>, label: label(r)};
				})
			);
		}

		return result;

	}, [items, createEnabled, label]);
}
